module.exports = __webpack_public_path__ + "img/open-tab.abe71047.svg";